// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { BrandingToolLinkGenerator } from './Branding/BrandingToolLinkGenerator';
import { BaseExtLink } from './BaseExtLink';
import { ResourcesManager } from '../../properties/ResourcesManager';
export class LinkTokenLangExtLink extends BaseExtLink {
    generateUrl() {
        const url = BrandingToolLinkGenerator.generateLinkTokenLangURL(this, ResourcesManager.getLanguageTag());
        if (url) {
            this.url = url;
            if (this.updateValue) {
                this.updateValue(url);
            }
        }
    }
}
